export default __webpack_public_path__ + "static/media/infoIconDark.a51243fe.svg";